// Block logo save/download
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.header-logo__image, .logo-block__image, .logo-section__image').forEach(function (img) {
    img.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    img.setAttribute('oncontextmenu', 'return false');
  });
});

// Flow PWA - Install prompt handler
(function () {
  let deferredPrompt = null;

  // Catch install prompt on Android/Chrome
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    showInstallBanner();
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    hideInstallBanner();
  });

  function showInstallBanner() {
    const banner = document.getElementById('pwa-install-banner');
    if (banner) banner.style.display = 'flex';
  }

  function hideInstallBanner() {
    const banner = document.getElementById('pwa-install-banner');
    if (banner) banner.style.display = 'none';
  }

  // Expose install trigger globally
  window.flowPWAInstall = function () {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => { deferredPrompt = null; });
    } else if (isIOS()) {
      document.getElementById('pwa-ios-instructions').style.display = 'block';
    } else {
      // Desktop/other: show instructions
      alert('Para instalar: clique nos 3 pontos do browser → "Instalar aplicação" ou "Adicionar ao ecrã inicial".');
    }
  };

  function isIOS() {
    return /iphone|ipad|ipod/i.test(navigator.userAgent);
  }

  function isInStandaloneMode() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
  }

  // Auto-show for iOS if not already installed
  document.addEventListener('DOMContentLoaded', function () {
    if (isIOS() && !isInStandaloneMode()) {
      showInstallBanner();
    }
  });

  // Register service worker (cache shell)
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', function () {
      const swScript = `
        const CACHE = 'flow-v1';
        const SHELL = ['/', '/collections/all'];
        self.addEventListener('install', e => {
          e.waitUntil(caches.open(CACHE).then(c => c.addAll(SHELL)).catch(() => {}));
          self.skipWaiting();
        });
        self.addEventListener('activate', e => {
          e.waitUntil(caches.keys().then(keys =>
            Promise.all(keys.filter(k => k !== CACHE).map(k => caches.delete(k)))
          ));
          self.clients.claim();
        });
        self.addEventListener('fetch', e => {
          if (e.request.method !== 'GET') return;
          e.respondWith(
            caches.match(e.request).then(cached => cached || fetch(e.request).then(resp => {
              if (resp && resp.status === 200 && e.request.url.includes(location.origin)) {
                const clone = resp.clone();
                caches.open(CACHE).then(c => c.put(e.request, clone));
              }
              return resp;
            }).catch(() => cached))
          );
        });
      `;
      const blob = new Blob([swScript], { type: 'application/javascript' });
      const swUrl = URL.createObjectURL(blob);
      navigator.serviceWorker.register(swUrl).catch(() => {});
    });
  }
})();
